import { ExclusionReason } from '@oaknorth/api-polaris';
import { Box, Flex, IconButton, ListItem, OnOutlineExpandDown, Text, useDisclosure } from '@oaknorth/component-core-v2';
import { useTranslation } from '@oaknorth/util-intl';

import { BorrowerSpreadAuditTable } from '../BorrowerSpreadAudit';

export interface ReasonDetailsProps {
  reason: ExclusionReason;
  borrowerId: string;
  borrowerName?: string;
}

export function ReasonDetails({ reason, borrowerId, borrowerName }: ReasonDetailsProps) {
  const { open, onOpen, onClose } = useDisclosure();
  const { t } = useTranslation();
  const isDisabled = reason.files.length === 0;

  // eslint-disable-next-line @oaknorth/ui/no-template-literals -- no user facing
  const reasonId = `reason-${reason.reason.replace(/\s+/g, '-')}`;

  return (
    <ListItem key={reason.reason} aria-labelledby={reasonId}>
      <Flex alignItems="center">
        <IconButton
          aria-label={
            isDisabled
              ? t`diagnostics.excludedBorrowerOverview.noSpreads`
              : open
              ? t`diagnostics.excludedBorrowerOverview.collapse`
              : t`diagnostics.excludedBorrowerOverview.expand`
          }
          size="lg"
          variant="ghost"
          disabled={isDisabled}
          onClick={() => (open ? onClose() : onOpen())}
        >
          <OnOutlineExpandDown
            transform={open ? 'rotate(-180deg)' : undefined}
            transition="transform 0.2s"
            transformOrigin="center"
            boxSize={6}
          />
        </IconButton>
        <Text as="b" fontSize="lg" id={reasonId}>
          {capitalise(reason.reason)}
        </Text>
      </Flex>

      {open &&
        reason.files.map((file) => (
          <Box padding={4} key={file.input_file_id}>
            <BorrowerSpreadAuditTable file={file} borrowerId={borrowerId} borrowerName={borrowerName} />
          </Box>
        ))}
    </ListItem>
  );
}

function capitalise(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
